import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon,
    Remove as RemoveIcon 
} from '@mui/icons-material';
import { styled } from '@mui/styles';

const StyledSpendingColumn = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: 35,
    [theme.breakpoints.down('xs')]: {
        flexDirection: 'column'
    }
}));

/**
 * @param coverage
 * @returns {string}
 */
const _defineSpendingAccountType = (coverage) => {
    let coverageType = 'N/A';

    if (coverage.meta.isPooled === 0 && coverage.health.hasBenefit === 1) {
        coverageType = 'Health';
    } else if (coverage.meta.isPooled === 0 && coverage.lifestyle.hasBenefit === 1) {
        coverageType = 'Lifestyle';
    } else if (coverage.meta.isPooled === 1 || (coverage.health.hasBenefit === 1 && coverage.lifestyle.hasBenefit === 1)) {
        coverageType = 'Health & Lifestyle Included';
    }

    return coverageType;
};

/**
 *
 * @param {*} props
 */
export default function SpendingAccounts({ classes, expanded, spendingAccounts, handleChange, lsaClaimTypes, isStudent }) {
    const half = Math.ceil(lsaClaimTypes?.length / 2);
    const left = lsaClaimTypes?.slice(0, half);
    const right = lsaClaimTypes?.slice(half, lsaClaimTypes?.length);

    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('spendingAccounts')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('spendingAccounts') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Spending Accounts</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        spendingAccounts.meta.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    }

                    <Text small bold margin="20px 0px 10px 0px">{ _defineSpendingAccountType(spendingAccounts) }</Text>

                    <Text small bold margin="5px 0px 10px 0px">
                        To view your current balance navigate to the Spending Accounts section.
                    </Text>
                    {
                        spendingAccounts.health.hasBenefit ?
                            <div style={classes.row}>
                                <Text small customStyle={{ flex: 1, marginBottom: 10 }}>
                                    {
                                        `You have $${ helpers.formatNumber(spendingAccounts.health.amount) } total in your Health Spending Account. `
                                    }
                                    {
                                        spendingAccounts.health.allowHsaRollover === 1 ? `Your remaining unspent balance ${ spendingAccounts.health.hasMaxRollover === 1 ? `to a maximum of $${ helpers.numberWithCommas(spendingAccounts.health.maxHsaRollover) }` : '' } will roll over to the next calendar year. ` : 'This benefit expires and unspent dollars will not roll over. '
                                    }
                                </Text>
                            </div>
                            : null
                    }

                    {
                        spendingAccounts.lifestyle.hasBenefit ?
                            <div style={classes.row}>
                                <Text small customStyle={{ flex: 1, marginBottom: 10 }}>
                                    {
                                        `You have $${ helpers.formatNumber(spendingAccounts.lifestyle.amount) } total in your Lifestyle Spending Account. `
                                    }
                                    {
                                        spendingAccounts.lifestyle.allowLsaRollover === 1 ? `Your remaining unspent balance ${ spendingAccounts.lifestyle.hasMaxRollover === 1 ? `to a maximum of $${ helpers.numberWithCommas(spendingAccounts.lifestyle.maxLsaRollover) }` : '' } will roll over to the next calendar year. ` : 'This benefit expires and unspent dollars will not roll over. '
                                    }
                                </Text>
                            </div>
                            : null
                    }

                    {
                        spendingAccounts.lifestyle.hasBenefit && lsaClaimTypes?.length > 0 ?
                            <React.Fragment>
                                <Text small bold margin="20px 0px 10px 0px">
                                    The following services qualify for Lifestyle Spending Claims for this member:
                                </Text>

                                <StyledSpendingColumn>
                                    <div style={classes.spendingRow}>
                                        {left.map((item) => <Text key={ item } small margin="0px 20px 0px 0px">{ item }</Text>)}
                                    </div>

                                    <div style={classes.spendingRow}>
                                        {right.map((item) => <Text key={ item } small margin="0px 20px 0px 0px">{ item }</Text>)}
                                    </div>
                                </StyledSpendingColumn>
                            </React.Fragment>
                            : null
                    }

                    {
                        isStudent ?
                            <Text small margin="5px 0px 0px 0px">{ `Terminates at age ${ spendingAccounts.meta.terminationAge } or date of participants study if earlier.` }</Text>
                            :
                            <Text small margin="5px 0px 0px 0px">{ `Terminates at age ${ spendingAccounts.meta.terminationAge } or date of participants retirement if earlier.` }</Text>
                    }

                </AccordionDetails>
            </Accordion>
        </div>
    );
}